import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import axios from 'axios';
export const getApps = createAsyncThunk(
    'Apps/getApps',
    async (lng) => {
        const res = await axios.get(`/Assets/translate_${lng}.json`);
        return res.data;
    }
);


export const AppSlice = createSlice({
    name: "Apps",
    initialState: {
        loading: true,
        translate: [],
    },
    extraReducers: (builder) => {
        builder.addCase(getApps.pending, (state, { payload }) => {
            state.loading = true;
        });

        builder.addCase(getApps.fulfilled, (state, { payload }) => {
            state.translate = payload
            state.loading = false



        });
        builder.addCase(getApps.rejected, (state, { payload }) => {
            state.loading = false;

        });

    },

})

export const AppReducer = AppSlice.reducer;